// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/js/views/create-event/CreateEvent.css
// module id = 2058
// module chunks = 0